import {
    FETCH_USERS_INIT_ACTION,
    FETCH_USERS_SUCCESS_ACTION,
    FETCH_USERS_FAIL_ACTION,
    CREATE_USER_INIT_ACTION,
    CREATE_USER_SUCCESS_ACTION,
    CREATE_USER_FAIL_ACTION,
    UPDATE_USER_STATUS_INIT_ACTION,
    UPDATE_USER_STATUS_SUCCESS_ACTION,
    UPDATE_USER_STATUS_FAIL_ACTION,
} from "./action";

const initialState = {
    usersList: [],
    usersCount: 0,
    loading: false,
    error: null,
    createLoading: false,
    createSuccess: false,
    statusLoading: false,
};

const UsersReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_USERS_INIT_ACTION:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case FETCH_USERS_SUCCESS_ACTION:
            return {
                ...state,
                loading: false,
                usersList: action.payload.rows,
                usersCount: action.payload.count,
            };
        case FETCH_USERS_FAIL_ACTION:
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case CREATE_USER_INIT_ACTION:
            return {
                ...state,
                createLoading: true,
                createSuccess: false,
                error: null,
            };
        case CREATE_USER_SUCCESS_ACTION:
            return {
                ...state,
                createLoading: false,
                createSuccess: true,
            };
        case CREATE_USER_FAIL_ACTION:
            return {
                ...state,
                createLoading: false,
                createSuccess: false,
                error: action.error,
            };
        case UPDATE_USER_STATUS_INIT_ACTION:
            return {
                ...state,
                statusLoading: true,
                error: null,
            };
        case UPDATE_USER_STATUS_SUCCESS_ACTION:
            return {
                ...state,
                statusLoading: false,
            };
        case UPDATE_USER_STATUS_FAIL_ACTION:
            return {
                ...state,
                statusLoading: false,
                error: action.error,
            };
        default:
            return state;
    }
};

export default UsersReducer;
